class AnnouncementBar extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.currentIndex = 0
    this.timer = null
    this.pausedByUser = false
    this.delay = this.getDelay()

    this.initialize()
  }

  setupListeners () {
    super.setupListeners()
  }

  getDelay () {
    const seconds = Number(this.dataset.transitionInterval)

    if (!Number.isFinite(seconds) || seconds <= 0) return 5000

    return seconds * 1000
  }

  prefersReducedMotion () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }

  initialize () {
    this.announcements = this.els.announcement.elements
    this.pauseButton = this.els.pause && this.els.pause.element

    if (this.announcements.length < 2) return

    if (this.pauseButton) {
      this.pauseButton.addEventListener('click', () => {
        this.setPaused(!this.pausedByUser)
      })
    }

    if (this.prefersReducedMotion()) {
      this.setPaused(true)
      return
    }

    this.startCycle()

    this.addEventListener('mouseenter', () => {
      if (!this.pausedByUser) this.stopCycle()
    })

    this.addEventListener('mouseleave', () => {
      if (!this.pausedByUser) this.startCycle()
    })
  }

  setPaused (paused) {
    this.pausedByUser = paused

    if (this.pauseButton) {
      this.pauseButton.setAttribute('aria-pressed', String(paused))

      const label = paused
        ? this.pauseButton.dataset.playLabel
        : this.pauseButton.dataset.pauseLabel

      if (label) this.pauseButton.setAttribute('aria-label', label)
    }

    if (paused) {
      this.stopCycle()
      return
    }

    this.startCycle()
  }

  startCycle () {
    this.stopCycle()
    if (this.pausedByUser || this.announcements.length < 2) return

    this.timer = setInterval(() => this.showNext(), this.delay)
  }

  stopCycle () {
    clearInterval(this.timer)
    this.timer = null
  }

  showNext () {
    const total = this.announcements.length
    const current = this.announcements[this.currentIndex]

    current.setAttribute('aria-hidden', 'true')
    current.setAttribute('inert', '')

    this.currentIndex = (this.currentIndex + 1) % total

    const next = this.announcements[this.currentIndex]

    next.removeAttribute('aria-hidden')
    next.removeAttribute('inert')
    this.syncPauseColour(next)
  }

  syncPauseColour (slide) {
    const colour = getComputedStyle(slide).getPropertyValue('--TextColour').trim()

    if (colour) this.style.setProperty('--PauseColour', colour)
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
